import React, { useState } from 'react';
import {
  Box,
  Text,
  Button,
  Divider,
  Popover,
  PopoverInteractiveWrapper,
  InfoIcon,
} from '@razorpay/blade/components';
import { SUPPORTED_PLACEHOLDERS } from '../../constants';
import { PlaceholderGroup } from './PlaceholderGroup';
import { PlaceholdersPopoverProps } from './types';

const PlaceholdersPopover = ({ actionType }: PlaceholdersPopoverProps) => {
  const [isOpen, setIsOpen] = useState(false);

  const showWorkflowPlaceholders = actionType === 'call_api';

  const popoverContent = (
    <Box padding="spacing.4" maxHeight="400px" overflowY="auto" width="280px">
      <Text weight="semibold" marginBottom="spacing.4">
        Available Placeholders
      </Text>
      <Text size="small" color="surface.text.gray.muted" marginBottom="spacing.4">
        Use these placeholders in your content. They will be replaced with actual values when the workflow runs.
      </Text>
      <Divider marginBottom="spacing.4" />
      <PlaceholderGroup title="AI Decision" placeholders={SUPPORTED_PLACEHOLDERS.ai_decision} />
      <PlaceholderGroup title="Employee Info" placeholders={SUPPORTED_PLACEHOLDERS.employee} />
      <PlaceholderGroup title="Reimbursement" placeholders={SUPPORTED_PLACEHOLDERS.reimbursement} />
      <PlaceholderGroup title="Leave Request" placeholders={SUPPORTED_PLACEHOLDERS.leave} />
      {showWorkflowPlaceholders && <PlaceholderGroup title="Workflow (API only)" placeholders={SUPPORTED_PLACEHOLDERS.workflow} />}
    </Box>
  );

  return (
    <Popover
      isOpen={isOpen}
      onOpenChange={({ isOpen: open }) => setIsOpen(open)}
      content={popoverContent}
      placement="bottom-start">
      <PopoverInteractiveWrapper>
        <Button
          variant="tertiary"
          size="small"
          icon={InfoIcon}
          iconPosition="left"
          onClick={() => setIsOpen(!isOpen)}>
          View supported placeholders
        </Button>
      </PopoverInteractiveWrapper>
    </Popover>
  );
};

export { PlaceholdersPopover };
